export const decisioningStudioAgentsAppGroupIdDsaIdAgentPreferences =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/agent_preferences";
